var s1 = "/static/d61ca9acbb010436.png";

export { s1 as default };
//# sourceMappingURL=s_1.png.js.map
